import {Grid} from '@material-ui/core';
import React, {useEffect, useState} from 'react';

import {FormDialog} from "../../../controls";
import AircraftListLookup from '../../Aircraft/components/AircraftListLookup';

const FilterAircraftDialog = (props) => {

  const classes = props.classes;
  const SystemData = props.systemData;

  const eventBus = SystemData.eventBus;

  const [dialogState, setDialogState] = useState({
    showDialog: false,
    title: 'Filter Aircraft',
    record: {hiddenAircraft: null}
  });

  const DisplayForm = () => {

    useEffect(()=> {

    },[]);

    const buttons = {
      reset:{icon: "replay", key: "Reset", label: "Reset", color: "primary"},
      save:{icon: "check_circle", key: "Update", label: "Apply Filter", color: "primary", disabled: (status)=>{return status.error}},
      cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
    } 
      
    return (
      <FormDialog
        title={dialogState.title}
        message="Please select the Aircraft you wish to hide."
        open={dialogState.showDialog}
        record={dialogState.record}
        dialogOptions={{width: "md", maxWidth: "md", fullWidth: false}}
        classes={classes}
        // validator={Validator}
        buttons = {buttons}
        onChange={(state) => {
          if (state.buttonPressed === "reset" ) {
            if (props.onChange) {
              if (props.onChange) {
                props.onChange({record: {hiddenAircraft: null}});
              }
              setDialogState({...dialogState, showDialog: false, record: {hiddenAircraft: null}});
            }
          } else if (state.buttonPressed === "save" ) {
            if (props.onChange) {
              props.onChange(state);
            }
            setDialogState({...dialogState, showDialog: false, record: {hiddenAircraft: null}});
          } else {
            setDialogState({...dialogState, showDialog: false, record: {hiddenAircraft: null}});
          }
        }}
      >
        <Grid container checkChildren={true} spacing={3}>
          {}
          <Grid item xs={12} checkChildren={true}>
            {(record) => (
              <AircraftListLookup 
                id="hiddenAircraft"
                canEdit={true}
                tailList={record?.hiddenAircraft || ''}
                allChecked={false}
                width={400}            
              />
            )}
          </Grid>
        </Grid>
      </FormDialog>
    )
  }

  useEffect(()=> {
    const open = async (params) => {
      const {record} = params;
      const title = 'Filter Aircraft';

      setDialogState({...dialogState, showDialog:true, record, title});
    }
    eventBus.bind("FilterAircraftDialog.open", open);
    return () => {
      eventBus.unbind("FilterAircraftDialog.open", open);
    }
  }, [dialogState, eventBus]);

  if (dialogState.showDialog) {
    return (
      <DisplayForm />
    )
  }
  return (<></>);
}

export default FilterAircraftDialog;
